import dayjs, { Dayjs } from 'dayjs';
import { array, boolean, mixed, object, string } from 'yup';

import { StreamerWheelType } from 'v2/types/StreamerWheelModel';

export const STREAMER_WHEEL_BONUS_MAX_LENGTH = 12;
export const LOTTERY_DESCRIPTION_MAX_LENGTH = 14;
export const STREAMER_WHEEL_DESCRIPTION_MAX_LENGTH = 19;

export const getDescriptionMaxLength = (type: StreamerWheelType) =>
  type === StreamerWheelType.LOTTERY ? LOTTERY_DESCRIPTION_MAX_LENGTH : STREAMER_WHEEL_DESCRIPTION_MAX_LENGTH;

export type StreamerWheelMetadataEntry = {
  key: string;
  value: string;
};

export type StreamerWheelForm = {
  type: StreamerWheelType;
  name: string;
  image390Id: string;
  link: string;
  bonus: string;
  description: string;
  endDate: Dayjs | null;
  isActive: boolean;
  metadata: StreamerWheelMetadataEntry[];
};

export const initialValues: StreamerWheelForm = {
  type: StreamerWheelType.WHEEL,
  name: '',
  image390Id: '',
  link: '',
  bonus: '',
  description: '',
  endDate: null,
  isActive: false,
  metadata: [],
};

export const validationSchema = object({
  type: mixed<StreamerWheelType>()
    .oneOf([StreamerWheelType.LOTTERY, StreamerWheelType.WHEEL])
    .required('Giveaway type is required'),
  name: string().trim().required('Giveaway name is required'),
  image390Id: string().trim().required('Partner logo is required'),
  link: string().trim().url('Link must be a valid URL').required('Link is required'),
  bonus: string()
    .trim()
    .max(STREAMER_WHEEL_BONUS_MAX_LENGTH, `Bonus must be at most ${STREAMER_WHEEL_BONUS_MAX_LENGTH} characters`)
    .required('Bonus is required'),
  description: string()
    .trim()
    .test('description-max-length', function (value) {
      const { type } = this.parent;
      const maxLength = getDescriptionMaxLength(type);

      if ((value ?? '').length <= maxLength) return true;

      return this.createError({
        message: `Description must be at most ${maxLength} characters`,
      });
    })
    .notRequired(),
  endDate: mixed<Dayjs>().nullable(),
  isActive: boolean().required(),
  metadata: array()
    .of(
      object({
        key: string().trim(),
        value: string().trim(),
      })
    )
    .notRequired(),
}).test('endDate-not-in-past', 'End date cannot be in the past', function (value) {
  if (value?.endDate == null) return true;
  if (dayjs(value.endDate).isAfter(dayjs())) return true;

  return this.createError({ path: 'endDate', message: 'End date cannot be in the past' });
});
